// extracted by mini-css-extract-plugin
export default {"menuBlock":"gF-z","title":"hF-z","nav":"iF-z","flexCell":"jF-z","facetLink":"kF-z"};